//http://192.168.68.111:8090/download/1684762392221
export class AppSettings {
  // Build  ng build --prod --build-optimizer
  public static HTTP_CONTENT_TYPE = "application/json";
  //QA
  // public static SERVER_URL = "http://65.108.210.114:9090/rest/api/v1/";
  //QA-New
  // public static SERVER_URL = "http://37.27.204.155:9090/rest/api/v1/";
  //PROD
  //public static SERVER_URL = "https://dvt-server.amiscm-rnaipl.com/rest/api/v1/"
  //UAT
  public static SERVER_URL = "https://dvt-server.amiscm-rnaipl.com/rest/api/v1/"
  //Local
  // public static SERVER_URL = "http://192.168.11.101:9090/rest/api/v1/";

  // public static SERVER_URL = "http://localhost:9090/rest/api/v1/";


  public static HTTP_ACCESS_CONTROL_ALLOW_ORIGIN = "*";

  // COMMON
  public static GET_ROLES = "roles";
  public static GET_ALL_SERVICES = "screens";
  public static CHANGE_TO_STATUS = "transportorderweb/";
  public static GET_STATUS = "project/status";
  public static GET_LABEL = "labels";
  public static GET_YARD_MASTER = "yarddetails";
  public static GET_ROW_MASTER = "yardmaster/bayrow/";

  // LOGIN
  public static USER_LOGIN = "security/login";
  public static CHANGE_PASSWORD = "security/changepassword";
  public static FORGET_PASSWORD = "security/forgotpassword";

  // SCREEN ASSIGNMENT

  // SESSION
  public static USER_SESSION = "check/session";

  // USER MANAGEMENT
  public static GET_ALL_USER = "users";
  public static CREATE_USER = "user";
  public static GET_USER_DETAILS = "user/";

  // VLM UPLOAD
  public static VLM_UPLOAD = "vlms";

  // TO MANAGEMENT
  public static VIN_VALIDATE = "transportordervin/findvin";
  public static DELETE_TO = "transportordervin/updatetoid/";
  public static TO_COUNT_NO = "transportorder/type/";

  // DEALER
  public static GET_DEALERS = "dealers";
  public static DEALER_DETAILS = "dealer/summary/search/";
  public static GET_TRUCK_DETAILS = "dealer/epod/vin/";

  // TRAPSPORTER
  public static GET_TRANSPORTER = "transporters";
  public static TRANSPORTER_DETAILS = "transporter/summary/";
  public static GET_TRANS_TRUCK_DETAILS = "transporter/epod/vin/";

  //Sale
  public static SaleSearch = "sales/summary/search";
  //Export
  public static EXPORT = "eal/report/vinNumber";
  // USER

  public static USER_DETAILS = "user/summary/";
  public static GET_USER_TRUCK_DETAILS = "user/epod/vin/";

  // EPOD FORM

  //public static POD_FORM_MASTER = 'pod_metadata/'
  public static SAVE_POD = "poddataweb";
  public static GET_IMAGES = "podimage/vin";
  public static POD_FORM_MASTER = "web/pod_metadata";

  // SERVICES ASSIGNMENT

  public static UPDATE_SERVICES = "role";

  // INVOICE

  public static INVOICE_SUBMIT = "bulk/invoicedetail";
  public static INVOICE_QUERY = "invoicedetail_by_to/";

  // DASHBOARD

  public static DEALER_DASH = "dealer/vincount/";
  public static DEALER_CHART = "dealer/vincount/status/";

  //DYM
  public static BAYS_COUNT = "user/bayscount";
  public static VINS_COUNT = "user/vinpgscount";

  // DTO
  public static TO_COUNT = "user/tostatuscount";
  public static HANDY_TO_COUNT = "user/terminalto";

  // EPOD
  public static EPOD_COUNT = "user/epodcount";
  public static ETA_COUNT = "transportordervin/etacount";
  public static TRACKING_CHART = "dealer/vincount/status/";

  // VIN TRACKING

  public static VIN_TRACKING = "trucktrackinglocations";
  public static VIN_TRACKING_PER = "trackinglocations/";
  public static VIN_TIMELINE = "vinstatushistory/findby/";
  public static VIN_TIMELINE_RACK = "rack/location";

  //public static DEALER_QUERY = "dealerQuery/";
  // public static TRANSPORTER_QUERY = "transporterQuery/";
  //public static OBL_QUERY = "queryAllTransport";
  //public static DEALER_SEARCH = "dealerSearch/";
  //public static TRANSPORTER_SEARCH = "transporterSearch/";
  //public static USER_SEARCH = "userSearch/";
  public static MENU_SERVICES_QUERY = "hrroleServices/queryByRoleId/";
  //public static GET_TRUCK_DETAILS = "getVinPerTruck/";
  // public static GET_TRANS_TRUCK_DETAILS = "getVinPerTruckTransport/";
  // public static GET_USER_TRUCK_DETAILS = "getVinPerTruckUser/"
  public static GET_INVOICE_DETAILS = "invoiceDetails/";
  public static GET_INVOICE_DETAILS_USER = "userInvoiceVINDetails/";
  public static GET_INVOICE_VIN_DETAILS = "invoiceVINDetails/";
  //public static INVOICE_SUBMIT = "invoiceSubmit"
  public static GET_INVOICE_LIST = "getInvoiceList/";
  public static GET_INVOICE_LIST_USER = "getUserInvoiceList/";
  // public static CHANGE_PASSWORD = "changePassword/";
  public static PRE_CHANGE_PASSWORD = "changePassword/";
  // public static FORGET_PASSWORD ="userfp/";
  public static GET_VIN_FORM = "queryVINStatus/";
  // public static SAVE_POD = "PODFormSubmit";
  public static GET_POD_STATUS = "vinSubmitCheck/";
  public static GET_PER_VIN_DETAILS = "vinDetailsCheck/";
  public static GET_EPOD_QUERY = "queryEPODFormClientTest/";
  public static GET_FORM_SELECTED_DATA = "pod_filled_values/";
  public static GET_FORM_DATA_QUERY = "queryEPODFormData/";
  public static LOGOUT = "security/logout";
  public static GET_ALL_TCODE = "get/transcode";
}
